import { PEOPLE_DIRECTORY_PATH } from '@townsquare/config/routes';
import { createGlobalRoute } from '@townsquare/router/create-route';

export const aggTeamsDirectoryRoute = createGlobalRoute({
	exact: true,
	name: 'agg-teams-directory',
	path: `${PEOPLE_DIRECTORY_PATH}/agg/:search(search)?`,
	subproduct: 'townsquare-people-agg-team-directory',
	query: ['screen=(SEARCH_TEAMS|YOUR_TEAMS)'],
	featureGating: {
		gates: ['enable-teams-tql-migration-to-agg'],
		behavior: { type: 'enabled' },
	},
});
